// `avatar pack status` — hiển thị version team-ai-pack đang cài.
//
// v3: pack là tarball (không git). Không còn so sánh tag remote (chưa có endpoint
// list-versions). Chỉ show version từ manifest + gợi ý `avatar sync` để cập nhật.
import { join } from "node:path";
import boxen from "boxen";
import type { Command } from "commander";
import { pathExists } from "../lib/filesystem-helpers.js";
import { readPinnedPackVersion } from "../lib/team-pack-submodule-manager.js";
import { chalk, log } from "../lib/terminal-logger.js";

const PACK_RELATIVE_PATH = ".claude/pack";

export function registerPackCommand(program: Command): void {
  const pack = program.command("pack").description("Quản lý team-ai-pack (status, ...)");

  pack
    .command("status")
    .description("Hiển thị version pack đang cài")
    .option("--json", "Output JSON cho script")
    .action(async (opts: { json?: boolean }) => {
      try {
        const snap = await gatherPackStatus(process.cwd());
        if (opts.json) {
          process.stdout.write(`${JSON.stringify(snap, null, 2)}\n`);
        } else {
          renderPackStatus(snap);
        }
      } catch (err) {
        log.error(err instanceof Error ? err.message : String(err));
        process.exit(1);
      }
    });
}

interface PackStatus {
  installed: boolean;
  currentVersion: string | null; // null khi chưa cài
}

async function gatherPackStatus(cwd: string): Promise<PackStatus> {
  const packDir = join(cwd, PACK_RELATIVE_PATH);
  if (!(await pathExists(packDir))) {
    return { installed: false, currentVersion: null };
  }
  const currentVersion = await readPinnedPackVersion(cwd).catch(() => null);
  return { installed: true, currentVersion };
}

function renderPackStatus(s: PackStatus): void {
  if (!s.installed) {
    const lines = [
      `${chalk.bold("team-ai-pack")} · ${chalk.yellow("chưa cài")}`,
      "─".repeat(48),
      chalk.dim("Chạy `avatar init` hoặc `avatar sync` để cài pack."),
    ];
    process.stdout.write(`${boxen(lines.join("\n"), { padding: 1, borderStyle: "round" })}\n`);
    return;
  }

  const current = s.currentVersion ?? chalk.yellow("(unknown)");
  const lines = [
    `${chalk.bold("team-ai-pack status")}`,
    "─".repeat(48),
    `${chalk.dim("Version hiện tại:")} ${current}`,
    "",
    chalk.dim("Cập nhật mới nhất: avatar sync"),
  ];
  process.stdout.write(`${boxen(lines.join("\n"), { padding: 1, borderStyle: "round" })}\n`);
}
